<template>
    <div class="header-wrapper">
        <div className="left">
            <SectionNav />

            <div className="select-container">
                <Checkbox
                    :indeterminate="someSelected"
                    :model-value="allSelected"
                    @onChange="filtersStore.selectAllFilters"
                >
                    Select all
                </Checkbox>

                <div v-if="totalVariations" class="variants-counter">
                    Selecting {{ selectedVariations }} of {{ totalVariations }} variations
                </div>
            </div>
        </div>

        <div className="right">
            <Button @click="$emit('close')">Go Back</Button>
            <Button type="primary" :disabled="selectedVariations === 0" @click="$emit('save')">Save</Button>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import SectionNav from "@/components/SectionNav.vue";

import { useConnectStore } from "@/Connect/store";
import { useConnectFiltersStore } from "@/Connect/store/filters";

const connectStore = useConnectStore();
const filtersStore = useConnectFiltersStore();

defineEmits(["close", "save"]);

const selectedVariations = computed(() => filtersStore.selectedVariations);
const totalVariations = computed(() => connectStore.totalVariations);

const allSelected = computed(() => selectedVariations.value === totalVariations.value);
const someSelected = computed(() => !allSelected.value && selectedVariations.value > 0);
</script>

<style lang="css" scoped>
.header-wrapper {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: 60px;

    background: #fff;
    border-bottom: 1px solid #c1c7cd;

    padding: 0 20px;
}

.select-container {
    display: flex;
    align-items: center;
}

.variants-counter {
    margin-left: 10px;
    padding-left: 10px;
    border-left: 1px solid #c1c7cd;
    display: flex;
    align-items: center;
}

.left,
.right {
    display: flex;
    gap: 10px;
    align-items: center;
}
</style>
